<template>
  <a-modal v-model="modal" title="新建" width="500px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form" :rules="rules">
        <a-form-model-item
          label="组织"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="organizationCode"
        >
          <global-select
            v-model="formData.organizationCode"
            v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
            selectType="selectAssemble"
            :selectData="inventOrg"
            :disabled="isDisableOrganization"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :assembleLabel="true"
            @change="inventOrgValueOnChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="人员编码"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="employeeCode"
        >
          <a-input v-model="formData.employeeCode" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="名称"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="employeeName"
        >
          <a-input v-model="formData.employeeName" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="编号"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="number"
        >
          <a-input v-model="formData.number" placeholder="请输入" :maxLength="64" />
        </a-form-model-item>
        <a-form-model-item
          label="性别"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="sex"
        >
          <a-select v-model="formData.sex" placeholder="请选择">
            <a-select-option value="女">女</a-select-option>
            <a-select-option value="男">男</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="系统账号"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="rmsAccount"
        >
          <a-input v-model="formData.rmsAccount" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="手机号"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="phoneNumber"
        >
          <a-input
            v-model="formData.phoneNumber"
            placeholder="请输入"
          />
        </a-form-model-item>
        <a-form-model-item
          label="邮箱"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="email"
        >
          <a-input v-model="formData.email" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item
          label="岗位"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="position"
        >
          <global-select
            :value.sync="formData.position"
            :selectData="positionList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="所属车间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workshopCode"
        >
          <global-select
            :value.sync="formData.workshopCode"
            :selectData="workshopList"
            selectType="selectAssembleFilter"
            :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import { apiEmployeeUpdate } from '@/api/mes/productionPrepare/employee'

export default {
  name: 'CreateModal',
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
    this.cacheLookupRequest('MES_ROLE', { lookupType: 'MES_ROLE', current: 1, pageSize: 999 }, 'positionList')
  },
  data() {
    return {
      modal: false,
      formData: {
        organizationCode: '', //  组织
        workshopCode: '', //  所属车间
        employeeName: '', // 员工名称
        employeeCode: '', // 员工编码
        number: '',
        sex: '', // 性别
        rmsAccount: '', // 系统账号
        phoneNumber: '', // 手机号码
        email: '', // 邮箱
        position: '' // 岗位
      },
      loading: false,
      rules: {
        organizationCode: [{ required: true, message: ' ', trigger: 'change' }],
        employeeName: [{ required: true, message: ' ', trigger: 'change' }],
        sex: [{ required: true, message: ' ', trigger: 'change' }],
        phoneNumber: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            message: "请输入正确的邮箱地址",
            trigger: ['blur', 'change']
          }
        ],
        employeeCode: [{ required: true, message: ' ', trigger: 'change' }]
      },
      positionList: [], // 岗位列表
      workshopList: [] // 车间列表
    }
  },
  methods: {
    // 初始化
    show () {
      this.$set(this.formData, 'organizationCode', this.organizationCodeOrigin)
      this.$set(this.formData, 'workshopCode', '')
      this.$set(this.formData, 'employeeName', '')
      this.$set(this.formData, 'employeeCode', '')
      this.$set(this.formData, 'number', '')
      this.$set(this.formData, 'sex', '')
      this.$set(this.formData, 'rmsAccount', '')
      this.$set(this.formData, 'phoneNumber', '')
      this.$set(this.formData, 'email', '')
      this.$set(this.formData, 'position', '')
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiEmployeeUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.formData.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
